// /auth/invited — Figma frame 04 invited (33:1411). Owner: screens-auth-b, US-090.
// Pre-login: deliberately no AppShell.

import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { InvitedScreen } from "../screens/invite/InvitedScreen";

export const authInvitedRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/auth/invited",
  component: InvitedScreen,
});
